import { render, staticRenderFns } from "./blessPackage.vue?vue&type=template&id=2a363556&scoped=true&"
import script from "./blessPackage.vue?vue&type=script&lang=js&"
export * from "./blessPackage.vue?vue&type=script&lang=js&"
import style0 from "./blessPackage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./blessPackage.vue?vue&type=style&index=1&id=2a363556&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a363556",
  null
  
)

component.options.__file = "blessPackage.vue"
export default component.exports